<template>
  <customer-details>
    <template v-slot:btnPrope>
      <v-btn
        class="t-btn--prm mr-5 ml-2"
        :disabled="!checkPerUser"
        @click="saveData"
      >
        保存
      </v-btn>
    </template>

    <div class="mx-5 mt-5">
      <h2 class="color-blue--drank mb-5">TVP合意解約日</h2>
      <v-card outlined class="pa-5">
        <p class="mb-2 description">
          指定した日の翌日からTVPの利用を制限します。日付を未指定にすると制限は解除されます。
        </p>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="tvpRestrictAfter"
              label="TVP合意解約日"
              prepend-inner-icon="mdi-calendar"
              readonly
              clearable
              :disabled="!checkPerUser"
              v-bind="attrs"
              v-on="on"
              style="max-width: 280px;"
              @click:clear="tvpRestrictAfter = null"
            ></v-text-field>
          </template>
          <v-date-picker
            :value="tvpRestrictAfter"
            :first-day-of-week="0"
            :locale="$i18n.locale"
            scrollable
            class="v-date-picker-custom"
            @input="onPick"
          ></v-date-picker>
        </v-menu>
      </v-card>
    </div>
  </customer-details>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CustomerDetails from '../CustomerDetails.vue';
import { checkPermissionUserCurrent } from '@/utils/permissions';

export default {
  name: 'customer-detail-tvp-restrict-after',
  components: { CustomerDetails },
  data() {
    return {
      checkPerUser: checkPermissionUserCurrent(this.$router.currentRoute),
      menu: false,
    };
  },
  computed: {
    ...mapGetters(['getClientTvpRestrictAfter']),
    tvpRestrictAfter: {
      get() {
        return this.getClientTvpRestrictAfter;
      },
      set(value) {
        this.setClientTvpRestrictAfter(value || null);
      },
    },
  },
  mounted() {
    this.loadClientTvpRestrictAfter(this.$route.params.id);
  },
  methods: {
    ...mapActions(['loadClientTvpRestrictAfter', 'updateClientTvpRestrictAfter']),
    ...mapMutations(['setClientTvpRestrictAfter']),
    onPick(value) {
      this.tvpRestrictAfter = value;
      this.menu = false;
    },
    async saveData() {
      await this.updateClientTvpRestrictAfter(this.$route.params.id);
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 20px !important;
  color: #0c6786;
  font-weight: bold !important;
}
.color-blue--drank {
  color: #004f8b !important;
}
.description {
  color: #666;
  font-size: 13px;
}
</style>
